import { render, staticRenderFns } from "./Organogram.vue?vue&type=template&id=31b1ab52&scoped=true"
import script from "./Organogram.vue?vue&type=script&lang=js"
export * from "./Organogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1ab52",
  null
  
)

export default component.exports